import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const ObligationsPage = lazy(() => import("@/features/dashboard/pages/obligations"));

export const Route = createFileRoute("/(app)/dashboard/obligations")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading…</div>}>
      <ObligationsPage />
    </Suspense>
  ),
});
